import ConfigForm from "@/components/DynamicForm/ConfigForm";
import CustomCaseConfigForm from "@/components/DynamicForm/CustomCaseConfigForm";
import CustomTaskForm from "@/components/DynamicForm/CustomTaskForm";
import CustomTeamForm from "@/components/DynamicForm/CustomTeamForm";
import CustomCaseTemplateConfigForm from "@/components/DynamicForm/CustomCaseTemplateConfigForm";

import ElasticList from "@/components/DynamicForm/ElasticList";
import DynamoList from "@/components/DynamicForm/DynamoList";
import CustomUserForm from "@/components/DynamicForm/CustomUserForm";

import Amplify, { API, graphqlOperation } from 'aws-amplify';
import gql from "graphql-tag";
import * as subscriptions from '@/graphql/subscriptions';
import * as queries from '@/graphql/queries';
import * as queries_custom from '@/graphql/queries_custom';
import * as mutations from "@/graphql/mutations";

export default {
  beforeRouteLeave (to, from, next) {
    this.$c.log('### Record.js beforeRouteLeave to:', to);
    this.$c.log('### Record.js beforeRouteLeave from:', from);
    this.$c.log('Record', this.recordData);
    
    if(this.recordData && this.recordData.id && from && from.name && from.fullPath) {
      let parsed = '';
      let pushObj = null;
      switch(from.name) {
        case 'View Account':
          pushObj = { id:this.recordData.id, model:'Account', title:this.recordData.name, link: '#'+from.fullPath, icon: 'work'};
          break;
        case 'View Service':
          pushObj = { id:this.recordData.id, model:'Service', title:this.recordData.name, link: '#'+from.fullPath, icon: 'styles'};
          break;
        case 'View Case':
          pushObj = { id:this.recordData.id, model:'Case', title:this.recordData.subject, link: '#'+from.fullPath, icon: 'how_to_vote'};
          break;
        case 'View Product':
          pushObj = { id:this.recordData.id, model:'Product', title:this.recordData.name, link: '#'+from.fullPath, icon: 'devices'};
          break;
        case 'View Salesrep':
          pushObj = { id:this.recordData.id, model:'Salesrep', title:this.recordData.given_name + ' ' +this.recordData.family_name, link: '#'+from.fullPath, icon: 'assignment_ind'};
          break;
        case 'View Portfolio':
          pushObj = { id:this.recordData.id, model:'Portfolio', title:this.recordData.name, link: '#'+from.fullPath, icon: 'folder'};
          break;
        default:
          break;
      }
      if(pushObj) {
        if(!_.isEqual(this.$Session.recentVisited[this.$Session.recentVisited.length - 1],pushObj)) {
          this.$Session.recentVisited.push(pushObj);
          while(this.$Session.recentVisited.length > 10 )
            this.$Session.recentVisited.shift();
          parsed = JSON.stringify(this.$Session.recentVisited);
          localStorage.setItem('recentVisited', parsed);
        }
      }  
    }
    
    // called when the route that renders this component is about to
    // be navigated away from.
    // has access to `this` component instance.
    if((to.params.id != '') && ((typeof from.params.id === 'undefined') && (this.formConfig.pageMode == 'new'))){
      if (to.params.id && this.subscriptions) {
        this.$loopo(this.subscriptions, (sub, name) => {
          this.$c.log('SUBSCRIPTION CONFIGURED: ' + name);
  
          if (typeof subscriptions[name] === 'undefined') {
            this.$c.error('SUBSCRIPTION [' + name + '] not found!');
            return;
          }
  
          let thisFunc = this.subscriptions[name].function;
          this.$apollo.queries.subscriptions.subscribeToMore({
            document: gql(subscriptions[name]),
            updateQuery: (previousResult, { subscriptionData }) => {
              console.log('SUBSCRIPTION ', name, subscriptionData);
              thisFunc({ value: subscriptionData });
            },
          });
        });
      }
    } else {
      if ((!to.params.id ||to.params.id !== from.params.id) && this.subscriptions) {
        this.$loopo(this.subscriptions, (sub, name) => {
          this.$c.log('Terminating SUBSCRIPTION: ' + name);

          if (sub.result) {
            this.subscriptions[name].result.unsubscribe();
          }
        });
      }
    }
    next();
  },
  components: {
    DynamoList,
    ConfigForm,
    ElasticList,
    CustomTaskForm,
    CustomCaseConfigForm,
    CustomTeamForm,
    CustomCaseTemplateConfigForm,
    CustomUserForm
  },
  props: {
    headerColor: {
      type: String,
      default: ""
    }
  },
  computed: {
    recordPath: function () { return this.formConfig.listPath + '/' + this.$route.params.id; },
  },
  methods: {
    pageTitleUpdate() {
      let objectHeaderContent = window.document.getElementById('objectHeaderContentHidden');
      let objectHeader = window.document.getElementById('objectHeader');
      let pageTitle = window.document.getElementById('pageTitle');

      if (objectHeaderContent && objectHeaderContent.innerHTML !== '' && objectHeader && pageTitle) {
        objectHeader.innerHTML = objectHeaderContent.innerHTML;
        pageTitle.classList.add('md-hide');
        objectHeader.classList.remove('md-hide');
      }
    },
    backToList() {
      if(this.$Session.tempRedirect && this.$Session.tempRedirect != "") {
        let tempRedirect = this.$Session.tempRedirect;
        delete this.$Session.tempRedirect;
        this.$router.push(tempRedirect);
      } else {
        this.$router.push(this.formConfig.listPath);  
      }
    },
    updateForm(data) {
      if (typeof data === 'undefined') return;

      // Update the simple fields
      let formData = data[this.formConfig.responseFieldName];
      if (formData) {
        this.recordData = formData;
        this.$c.log("updateForm recordData set: ", formData);
        this.$loopo(this.formConfig.fields, (field, key) => {
          if (typeof formData[key] !== 'undefined' && formData[key] !== null) {
            if (field.type === 'json') {
              let jsonFields = JSON.parse(formData[key]);
              this.$loopo(field.fields, (item, name) => {
                if (typeof jsonFields[name] !== 'undefined')
                  this.form[key].fields[name] = jsonFields[name];
                //this.formConfig.fields[key].fields[name] = jsonFields[name];
              });
            } else {
              this.setFormField(key, formData[key]);
            }
          } else{
            if (field.type === 'json') {                         
              this.$loopo(field.fields, (item, name) => {            
                this.$v.form[key].fields[name].$model = '';    
              });
            } else{
              this.$v.form[key].$model = '';                           
            }
          }
        });
        this.formConfig.pageMode = 'view';
      } else if (this.$route.params.id) {
        this.$c.log("Unable to locate record");
        // Unable to locate record
        if (this.$route.meta && this.$route.meta.tab) {
          this.formConfig.pageMode = "new";
        } else {
          window.$bus.$emit("page-not-found");
        }
      } else {
        this.$c.log("new pagemode");
        this.formConfig.pageMode = 'new';
      }

      if (this.updateFormAfter) {
        /** this is located inside the calling file i.e. Person, Company, etc. */
        this.updateFormAfter(data);
      }

      this.$nextTick(() => {
        setTimeout(() => {
          this.$c.log('Form state reset after update');
          this.$v.$reset();
        }, 1000);
        /** TODO: This is a hack. approvalDate and autoComplete fields seem to update themselves async so they end up being dirty even after reset without the 1000 wait */

        setTimeout(() => {
          // if (this.$v.form.approvalDate.$dirty || this.$v.form.approvalDate.$anyDirty) {
          //   this.$c.log('Please let developer know race condition is present on form.');
          // }
        }, 1500);
      });
    },
    setFormField(field, value) {
      if (typeof field === "object") {
        value = field.target.value;
        field = field.target.name;
      }
      //this.$c.log("setFormField(field=" + field + ", value=" + value + ")");
      // if (typeof this.formConfig.fields[field] !== 'undefined' && typeof this.$v.formConfig.fields[field].value.$model !== 'undefined') {
      //   this.$v.formConfig.fields[field].value.$model = value;
      if (typeof this.form[field] !== 'undefined' && typeof this.$v.form[field].$model !== 'undefined') {
        this.$v.form[field].$model = value;
      } else {
        this.$c.log("setFormField() UNABLE TO UPDATE! [" + field + "]");
      }
    },
    updateRecordData(item) {
      this.$c.log('inside updateRecordData', item);
      this.formConfig.refreshRecordData = true;
      /** the line below is covered by subscriptions now */
      //this.accountsList.refreshData = true;
    }
  },
  watch: {
    'recordData'() {
      this.$nextTick(this.pageTitleUpdate);
    },
  },
  apollo: {
    subscriptions: {
      query: function() {
        return gql(queries['searchUsers']);
      },
      variables: {
        filter: { id: { eq: '-1' } },
        limit: 1,
      },
      update: () => [],
    }
  },
  mounted () {
    if (this.$route.params.id && this.subscriptions) {
      this.$loopo(this.subscriptions, (sub, name) => {

        if (typeof subscriptions[name] === 'undefined') {
          this.$c.error('SUBSCRIPTION [' + name + '] not found!');
          return;
        }

        let thisFunc = this.subscriptions[name].function;
        this.$apollo.queries.subscriptions.subscribeToMore({
          document: gql(subscriptions[name]),
          updateQuery: (previousResult, { subscriptionData }) => {
            // console.log('SUBSCRIPTION ', name, subscriptionData);
            thisFunc({ value: subscriptionData });
          },
        });
      });
    } else if (this.subscriptions) {
      this.$loopo(this.subscriptions, (sub, name) => {
        if (this.subscriptions[name].load) {
          this.$c.log('SUBSCRIPTION CONFIGURED: ' + name);
          if (typeof subscriptions[name] === 'undefined') {
            this.$c.error('SUBSCRIPTION [' + name + '] not found!');
            return;
          }
          let thisFunc = this.subscriptions[name].function;
          this.$apollo.queries.subscriptions.subscribeToMore({
            document: gql(subscriptions[name]),
            updateQuery: (previousResult, { subscriptionData }) => {
              console.log('SUBSCRIPTION ', name, subscriptionData);
              thisFunc({ value: subscriptionData });
            },
          });
        }
      });
    }
  },
  data() {
    return {
      recordData: null,
      formConfig: {
        refreshRecordData: false,
        responseFieldName: '',
        actions: {},
        slots: {},
        listPath: '',
        headerIcon: '',
        objectName: '',
        objectNamePlural: '',
        editMode: false,
        pageMode: 'new', // can be one of ['new', 'view' 'edit']
        fields: {},
        editTitleField: 'name'
      },
      form: {},
      
    };
  },
};